exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".upgrade-to-premium{align-items:center;display:flex;flex-direction:column}.upgrade-to-premium__full-width{max-width:450px;text-align:left;width:100%}@media (max-width: 639px){.upgrade-to-premium{align-items:center}}\n", ""]);

// exports
exports.locals = {
	"upgrade-to-premium": "upgrade-to-premium",
	"upgrade-to-premium__full-width": "upgrade-to-premium__full-width"
};